import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84cfac44"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error feedback"
}
const _hoisted_2 = {
  key: 1,
  class: "success feedback"
}
const _hoisted_3 = {
  key: 2,
  class: "feedback"
}
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "radio-list" }

import {ref, computed, reactive} from 'vue'

  import RadioInput from '@/components/inputs/RadioInput'

  import useValidate from '@vuelidate/core'
  import {required} from '@vuelidate/validators'

  import {t} from '@/lib/i18n'
  import {useStore} from 'vuex'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'AnswerForm',
  props: {
    modelValue: null,
    options: null,
    errors: null,
    rightAnswer: null,
    progress: null
  },
  emits: ["update:modelValue", "submit", "cancel"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:modelValue', value: object): void
    (e: 'submit', value: object): void
    (e: 'cancel'): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: object
    options: [object]
    errors: object
    rightAnswer: number
    progress: number
  };

  const store = useStore()

  const wrongText = computed(() => t(store, 'training.wrong'))
  const rightText = computed(() => t(store, 'training.success'))
  const instructionText = computed(() => t(store, 'training.instruction'))

  const trad = (key) => {
    return computed(() => t(store, key)).value
  }

  

  

  const rightAnswer = ref(props.rightAnswer)

  const resource = computed({
    get() {
      return reactive(props.modelValue)
    },

    set(value) {
      emit('update:modelValue', value)
    }
  })

  const rules = computed(() => {
    return {
      answer: {
        rightAnswer: (value) => {
          return value.value === rightAnswer.value
        },
        required: required
      }
    }
  })

  const v$ = useValidate(rules, resource)

  const onChange = function () {
    v$.value.answer.$touch()

    const timeout = process.env.NODE_ENV === 'development' ? 0 : 2000

    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

    if (v$.value.$anyDirty && !v$.value.$invalid) {
      if (props.progress == 100 && isIOS) onSubmit()
      else {
        setTimeout(() => {
          onSubmit()
        }, timeout)
      }
      /*
      setTimeout(() => {
        onSubmit()
      }, timeout)
      */
    }
  }

  const onSubmit = function () {
    emit('submit', resource)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["answer-form", {'is-invalid': _unref(v$).$invalid}])
  }, [
    (_unref(v$).$anyDirty && _unref(v$).$invalid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(wrongText)), 1))
      : _createCommentVNode("", true),
    (_unref(v$).$anyDirty && !_unref(v$).$invalid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(rightText)), 1))
      : _createCommentVNode("", true),
    (!_unref(v$).$anyDirty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(instructionText)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, [
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
          return (_openBlock(), _createElementBlock("li", {
            key: option.value,
            class: "radio-list-item"
          }, [
            (_openBlock(), _createBlock(_unref(RadioInput), {
              key: option.value,
              modelValue: _unref(resource).answer,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(resource).answer) = $event)),
              label: trad(option.key),
              value: option,
              class: _normalizeClass({'is-invalid': _unref(v$).$invalid}),
              "known-answer": true,
              onChange: onChange
            }, null, 8, ["modelValue", "label", "value", "class"]))
          ]))
        }), 128))
      ])
    ], 40, _hoisted_4)
  ], 2))
}
}

})